import React from 'react';
import type { Dealer } from '../../../models/dealer';
import searchStateContext from '../../../contexts/map-context';

export const DEFAULT_NR_OF_RESULTS = 7;
const DEFAULT_DISPLAY_RESULTS_INDEX = 0;

const getResults = (results: Dealer[], displayResultsIndex: number) => {
  if (results.length <= DEFAULT_NR_OF_RESULTS) return results;

  return results.slice(0, displayResultsIndex + DEFAULT_NR_OF_RESULTS);
};

export const useDisplayResults = (): [Dealer[], () => void] => {
  const { results } = searchStateContext.useMapState();
  const [displayState, setDisplayState] = React.useState<{
    trackedResults: Dealer[] | null | undefined;
    index: number;
  }>({
    trackedResults: results,
    index: DEFAULT_DISPLAY_RESULTS_INDEX,
  });

  const displayResultsIndex =
    displayState.trackedResults === results ? displayState.index : DEFAULT_DISPLAY_RESULTS_INDEX;

  const displayResult = getResults(results || [], displayResultsIndex);

  return [
    displayResult,
    () => {
      setDisplayState((currentState) => {
        const currentIndex =
          currentState.trackedResults === results
            ? currentState.index
            : DEFAULT_DISPLAY_RESULTS_INDEX;

        return {
          trackedResults: results,
          index: currentIndex + DEFAULT_NR_OF_RESULTS,
        };
      });
    },
  ];
};
